import { render, staticRenderFns } from "./RewardLogBody.vue?vue&type=template&id=e148e5a8&"
import script from "./RewardLogBody.vue?vue&type=script&lang=ts&"
export * from "./RewardLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports